// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database'; // ✅ Add this
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAcAh17engmeY1_5S8lEtJ8KcS6zoEsXuE",
  authDomain: "sagar-power.firebaseapp.com",
  projectId: "sagar-power",
  storageBucket: "sagar-power.appspot.com",
  messagingSenderId: "422773408983",
  appId: "1:422773408983:web:e5242a464b9add27ccdc92",
  measurementId: "G-ERTV3SKQK1"
};

const app = initializeApp(firebaseConfig);

// ✅ Add this line
const realtimeDb = getDatabase(app);

// Existing Firestore and Auth
const db = getFirestore(app);
const auth = getAuth(app);

// ✅ Export realtimeDb also
export { db, auth, realtimeDb };
